import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import {
    Router,
    Route,
    Redirect,
    IndexRoute,
    browserHistory,
    RouterState,
    RedirectFunction
} from "react-router";
import { routerMiddleware, syncHistoryWithStore } from "react-router-redux";

import thunkMiddleware from "redux-thunk";

const reduxDevtoolsExtension = require("redux-devtools-extension");
const reduxPersist = require("redux-persist");

import App from "./containers/App";
import Login from "./containers/Login";
import Main from "./containers/Main";

import reducers from "./redux";

const store = createStore(reducers, reduxDevtoolsExtension.composeWithDevTools(
    applyMiddleware(routerMiddleware(browserHistory), thunkMiddleware)
), reduxPersist.autoRehydrate());

function requireAuth(nextState: any, replace: any) {
    let loggedIn = store.getState().auth.logged;
    if (!loggedIn) {
        replace({
            pathname: '/login',
            state: {
                nextPathname: nextState.location.pathname
            }
        })
    }
}

const history = syncHistoryWithStore(browserHistory, store)

reduxPersist.persistStore(store, {
    whitelist: ["auth"]
}, () => {
    render((
        <Provider store={store}>
            <Router history={history}>
                <Route path="/" component={App}>
                    <IndexRoute onEnter={requireAuth} component={Main}/>
                    <Route path="/login" component={Login}/>                     
                </Route>
            </Router>
        </Provider>
    ), document.getElementById("app"));
});



// WEBPACK FOOTER //
// ./src/index.tsx